import type { RouteType } from "@/hooks/useIncentives"

export const ROUTE_TYPE_LABELS: Record<RouteType, string> = {
  completed: "Completed route",
  split_original: "Route which was split",
  split_off: "Split-off route",
  rescue: "Rescue route",
  rescued_not_fault: "Route which was rescued (not driver's fault)",
  rescued_fault: "Route which was rescued (driver's fault)",
  abandoned_not_fault: "Route which was abandoned and not rescued (not driver's fault)",
  abandoned_fault: "Route which was abandoned and not rescued (driver's fault)",
}

export const ROUTE_TYPE_HINTS: Record<RouteType, string> = {
  completed: "The driver's own route, finished, and nobody split or rescued it.",
  split_original:
    "Part of the driver's route was taken off before it started, and they finished the rest.",
  split_off: "The part taken off someone else's route, finished by this driver.",
  rescue: "The driver took over stops from someone else's started route and finished them.",
  rescued_not_fault:
    "The driver's route was taken over partway through, such as when the van broke down.",
  rescued_fault:
    "The driver's route was taken over partway through, and Ops marked it as their fault.",
  abandoned_not_fault: "The driver didn't finish and nobody took over the rest.",
  abandoned_fault: "The driver didn't finish, nobody took over the rest, and it was their fault.",
}

// The form groups the types by what happened to the route, so related ones sit side by side.
export const ROUTE_TYPE_GROUPS: { label: string; types: RouteType[] }[] = [
  { label: "Completed", types: ["completed"] },
  { label: "Split", types: ["split_original", "split_off"] },
  { label: "Rescue", types: ["rescue"] },
  { label: "Rescued", types: ["rescued_not_fault", "rescued_fault"] },
  { label: "Abandoned (not rescued)", types: ["abandoned_not_fault", "abandoned_fault"] },
]

// The form's checkbox text, which sits beside its group's label and so leaves out what that says.
export const ROUTE_TYPE_OPTION_LABELS: Record<RouteType, string> = {
  completed: "Completed route",
  split_original: "Original route",
  split_off: "Split-off route",
  rescue: "Rescue route",
  rescued_not_fault: "Not driver's fault",
  rescued_fault: "Driver's fault",
  abandoned_not_fault: "Not driver's fault",
  abandoned_fault: "Driver's fault",
}

// How the rule summary names each type, as the word before "route".
export const ROUTE_TYPE_ADJECTIVES: Record<RouteType, string> = {
  completed: "completed",
  split_original: "split",
  split_off: "split-off",
  rescue: "rescue",
  rescued_not_fault: "rescued (not driver's fault)",
  rescued_fault: "rescued (driver's fault)",
  abandoned_not_fault: "abandoned (not driver's fault)",
  abandoned_fault: "abandoned (driver's fault)",
}
